/**
 * Not supported on the web
 */
export const restoreAllInAppPurchases = async (): Promise<void> => {}
